import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Lock, Mail, Loader2, ChevronRight } from 'lucide-react';
import { login as loginApi } from '../../services/api'; // Используем готовую функцию из api.js

const Login = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const navigate = useNavigate();

    const handleLogin = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError('');

        try {
            // Используем оптимизированный метод из api.js
            // Он сам запишет token и user в localStorage, так как мы это прописали в api.js
            const data = await loginApi({ email, password });
            
            // Если мы здесь, значит запрос успешен (интерцептор не выкинул 401/error)
            // Редирект на основе роли
            if (data.user?.role === 'manager') {
                navigate('/timer');
            } else {
                navigate('/dashboard');
            }
            
            // Форсируем перезагрузку, чтобы Navigation подхватил новые данные из localStorage
            window.location.reload(); 

        } catch (err) {
            // Обрабатываем ошибку. Если сервер прислал JSON с message, берем его.
            const message = err.response?.data?.message || 'Неверный логин или пароль';
            setError(message);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-screen bg-[#0f172a] flex items-center justify-center p-4 sm:p-6 relative overflow-hidden">
            {/* Декоративные фоновые элементы */}
            <div className="absolute top-[-10%] left-[-10%] w-[40%] h-[40%] bg-indigo-600/10 rounded-full blur-[120px]" />
            <div className="absolute bottom-[-10%] right-[-10%] w-[40%] h-[40%] bg-purple-600/10 rounded-full blur-[120px]" />

            <div className="w-full max-w-md relative z-10 px-1">
                <div className="text-center mb-10">
                    <h1 className="text-4xl font-black text-white italic uppercase tracking-tighter">
                        ҮРКЕР <span className="text-indigo-500">CRM</span>
                    </h1>
                    <p className="text-slate-500 text-[10px] font-black uppercase tracking-[0.4em] mt-2">
                        Система управления доступом
                    </p>
                </div>

                <div className="bg-[#1e293b]/40 backdrop-blur-2xl border border-white/5 rounded-2xl sm:rounded-[3rem] p-6 sm:p-8 md:p-10 shadow-3xl">
                    <form onSubmit={handleLogin} className="space-y-6">
                        
                        {error && (
                            <div className="bg-rose-500/10 border border-rose-500/20 text-rose-400 text-xs font-bold py-4 px-6 rounded-2xl animate-shake">
                                {error}
                            </div>
                        )}

                        <div className="space-y-2">
                            <label className="text-[10px] font-black text-slate-500 uppercase ml-4 tracking-widest">Рабочая почта</label>
                            <div className="relative group">
                                <Mail className="absolute left-5 top-1/2 -translate-y-1/2 text-slate-500 group-focus-within:text-indigo-500 transition-colors" size={18} />
                                <input 
                                    required
                                    type="email" 
                                    className="w-full bg-slate-900/50 border border-white/5 rounded-2xl pl-14 pr-6 py-4 text-sm outline-none focus:border-indigo-500/50 text-white transition-all focus:bg-slate-900"
                                    placeholder="name@company.com"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                />
                            </div>
                        </div>

                        <div className="space-y-2">
                            <label className="text-[10px] font-black text-slate-500 uppercase ml-4 tracking-widest">Пароль</label>
                            <div className="relative group">
                                <Lock className="absolute left-5 top-1/2 -translate-y-1/2 text-slate-500 group-focus-within:text-indigo-500 transition-colors" size={18} />
                                <input 
                                    required
                                    type="password" 
                                    className="w-full bg-slate-900/50 border border-white/5 rounded-2xl pl-14 pr-6 py-4 text-sm outline-none focus:border-indigo-500/50 text-white transition-all focus:bg-slate-900"
                                    placeholder="••••••••"
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                />
                            </div>
                        </div>

                        <button 
                            disabled={loading}
                            type="submit"
                            className="w-full bg-indigo-600 hover:bg-indigo-500 disabled:bg-indigo-800 text-white py-5 rounded-[2rem] font-black text-[11px] uppercase tracking-[0.2em] mt-4 transition-all shadow-xl shadow-indigo-500/20 flex items-center justify-center gap-2 group"
                        >
                            {loading ? (
                                <Loader2 className="animate-spin" size={18} />
                            ) : (
                                <>
                                    Войти в систему
                                    <ChevronRight size={16} className="group-hover:translate-x-1 transition-transform" />
                                </>
                            )}
                        </button>
                    </form>
                </div>

                <p className="text-center mt-8 text-slate-600 text-[9px] font-bold uppercase tracking-widest">
                    &copy; 2026 ҮРКЕР CRM v1.0.0 — Secure Access
                </p>
            </div>
        </div>
    );
};

export default Login;
